// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ifMy","select":"styles_select__3uVp9"};